// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3B-v_","footer":"ModalInfo_footer__18H-t"};